import { Briefcase, Cake, UtensilsCrossed, Grape, Flame, Sandwich, Gift } from "lucide-react";
import { Reveal } from "./Reveal";
import { SERVICES } from "../data/content";

const ICONS = { Briefcase, Cake, UtensilsCrossed, Grape, Flame, Sandwich, Gift };

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="bg-[#1A1A1A] py-28 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-4">What We Do</p>
            <h2 className="font-serif-e text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#F9F9F6]">
              Seven ways we serve.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="text-[#F9F9F6]/60 max-w-sm text-base leading-relaxed">
              Every event is different. We build each catering solution around your guests, budget, menu preferences and presentation expectations.
            </p>
          </Reveal>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#F9F9F6]/10 border border-[#F9F9F6]/10">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.title} delay={(i % 3) * 0.1} className={i === 0 ? "lg:col-span-2" : ""}>
                <article data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                         className="group bg-[#1A1A1A] p-8 md:p-10 h-full hover:-translate-y-2 transition-transform duration-500 border border-transparent hover:border-[#D4AF37]/50 hover:bg-[#0A0A0A]">
                  <Icon size={26} strokeWidth={1} className="text-[#D4AF37]" />
                  <h3 className="font-serif-e text-2xl md:text-3xl text-[#F9F9F6] mt-6">{s.title}</h3>
                  <p className="text-[#F9F9F6]/60 text-sm leading-relaxed mt-3">{s.desc}</p>
                  <ul className="mt-5 flex flex-wrap gap-2">
                    {s.items.map((it) => (
                      <li key={it} className="text-[10px] uppercase tracking-[0.15em] text-[#F9F9F6]/50 border border-[#F9F9F6]/15 rounded-full px-3 py-1 group-hover:border-[#D4AF37]/40 transition-colors">
                        {it}
                      </li>
                    ))}
                  </ul>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
